import { observer }              from 'mobx-react-lite';
import currentProjectEditorStore from '@/TokamapEditor/stores/currentProjectEditorStore';
import FieldModel                from '@models/map/FieldModel';
import leftSidebarStore          from '@/TokamapEditor/stores/leftSidebarStore';
import ListCollection            from '@widesk-ui/components/listCollection/ListCollection';
import View                      from '@widesk-ui/components/View';
import useTheme                  from '@widesk-ui/hooks/useTheme';
import FieldTypeModel            from '@models/map/FieldTypeModel';
import SelectFieldType           from '@selects/map/SelectFieldType';
import InputBooleanUncheckable   from '@widesk-ui/components/form/InputBooleanUncheckable';
import actionModel               from '@widesk-ui/tools/actionModel';
import { DeleteOutlined }        from '@ant-design/icons';
import { Modal }                 from '@widesk-ui/components/modal/Modal';
import { message }               from '@widesk-ui/hooks/useMessage';
import { functionalityStore }    from '@/components/Functionality';
import CompactControls from '@/TokamapEditor/ux/CompactControls';

const FieldListSidebar = observer(() => {
	const projectEditor = currentProjectEditorStore.get;
	const project = projectEditor.project;

	const theme = useTheme();

	return (
		<CompactControls>
			<ListCollection
				clickable
				manualActiveIndex
				onDidMount={listStore => {
					if (!leftSidebarStore.getListStore('fields')) {
						leftSidebarStore.setListStore('fields', listStore);
					}
				}}
				onFetchCollectionStart={async coll => {
					coll.setRequiredFilter('project', project.id);
				}}
				pagination={{ pageSize: 10 }}
				modelClass={FieldModel}
				itemProps={(m, listStore) => ({
					title: m.renderName({ showType: true }),
					subTitle: m.reference
						?
						<View mt={-8} color={theme.colorTextDescription} size={theme.sizeSM}>Référence: {m.reference}</View>
						: undefined,
					// Ni ajout ni modification : le nom d'un champ se change en place dans la fiche du type, et
					// sa référence par l'action dédiée de cette même fiche. Cette liste ne sert donc plus qu'à
					// voir tous les champs du projet et à en supprimer.
					actions: [
						actionModel.delete(m, {
							actionProps: { label: 'Supprimer' },
							callback: async () => {
								functionalityStore.refreshUsagesOf('place_field_limit');
								await listStore.reload();
							},
						}),
					],
					extraProps: {
						paddingH: 'md',
						paddingV: 'sm',
					},
				})}
				massActions={(selected, listStore) => [
					{
						danger: true,
						icon: <DeleteOutlined />,
						label: `Supprimer la sélection (${selected.length})`,
						onClick: async () => {
							const modelsLabel = FieldModel.localize(selected.length > 1 ? 'plural' : 'default', 'l');
							const numberModelsLabel = `${selected.length} ${modelsLabel}`;
							return Modal.confirm({
								okText: 'Confirmer la suppression',
								okType: 'danger',
								title: `Supprimer ${numberModelsLabel} ?`,
								onOk: async () => {
									try {
										await Promise.all(selected.map(field => field.destroy()));
										functionalityStore.refreshUsagesOf('place_field_limit');
										message.success(`La sélection de ${numberModelsLabel} a bien été supprimée.`);

										return listStore.reload();
									} catch (err) {
										message.exception(err);
									}
								},
							});
						},
					},
				]}
				collectionFilters={{
					fieldType: {
						label: FieldTypeModel.localize(),
						element: <SelectFieldType identifier="id" multiple />,
						filter: 'fieldType',
					},
					hasReference: {
						label: `Possède une référence`,
						element: <InputBooleanUncheckable />,
						filter: 'exists[reference]',
						span: 12,
					},
				}}
				collectionSorts={{
					label: {
						labels: ['De A à Z', 'De Z à A'],
						value: 'label',
					},
					createdAt: {
						labels: ['Du plus récent au plus ancien', 'Du plus ancien au plus récent'],
						value: 'createdAt',
					},
				}}
				defaultSortName="label"
				storageKey="fields"
			/>
		</CompactControls>
	);
});

export default FieldListSidebar;